﻿export enum Types {
    Bool = "boolean",
    Function = "function",
    Number = "number",
    BigInt = "bigint",
    Object = "object",
    String = "string",
    Symbol = "symbol",
    Undefined = "undefined",

    /**Type is one of 'boolean|number|bigint|object|string|symbol' */
    NotFunction = "notfunction",
}